import fetch from 'isomorphic-fetch'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'
import { getCurrentEnvConfig } from '../../config'

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      DatasetFamily: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
    },
  }),
  link: new HttpLink({
    uri: getCurrentEnvConfig().graphql,
    fetch,
  }),
})

export default client
